import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { updatePersonalizedPetitionTask } from './api';
import type { UpdateTaskErrorCode } from './constants';
import { parseUpdateTaskError } from './constants';
import type { UpdatePersonalizedPetitionTaskResponse } from './types';

export type MutateSuccess = { status: 'loaded'; data: UpdatePersonalizedPetitionTaskResponse };
export type MutateFailure = { status: 'error'; error: UpdateTaskErrorCode };
export type MutateResult = MutateSuccess | MutateFailure;

export async function executeMutation(
	input: Parameters<typeof updatePersonalizedPetitionTask>[0],
	utilityContext: UtilityContext,
): Promise<MutateResult> {
	try {
		const data = await updatePersonalizedPetitionTask(input, utilityContext);
		return { status: 'loaded', data };
	} catch (e) {
		return { status: 'error', error: parseUpdateTaskError(e) };
	}
}
